import { StyleSheet } from 'aphrodite/no-important';
import { color, iconUrl } from './vars';
import {media} from "./constants";

export const playIcon = StyleSheet.create({
	icPlay: generatePlayIconStyleObj(iconUrl.icPlayMed, '45px'),
	icPlayBig: generatePlayIconStyleObj(iconUrl.icPlayMed, '68px'),
	icPlayTiny: generatePlayIconStyleObj(iconUrl.icPlayTiny, '25px'),
	icPlayHover: {
		backgroundColor: color.black,
		transform: 'scale(1.05)'
	}
});

export const icons = StyleSheet.create({

	icCloseIconWhite:{
		background: `url(${iconUrl.closeIconWhite})`,
		display: 'block',
		width: '18px',
		height: '18px',
	},

	icUpNext: {
		background: `url(${iconUrl.upNext})`,
		display: 'block',
		width: '64px',
		height: '13px',
		marginBottom: '5px',
		backgroundSize: 64
	},

	icFs: {
		background: `url(${iconUrl.fsWhite})`,
		display: 'block',
		backgroundSize: '59px',
		width: '59px',
		height: '35px',
	}
});

export const shareIcons = StyleSheet.create({
	inlineContainer:{
		display: 'inline-flex',
		marginBottom: '20px'
	},

	icLinkShare: generateIcShareStyleObj(iconUrl.icUrlLink, {border: 'none', outline: 'none'}),

	icWhatsappShare: {
		display: 'block',
		background: `url(${iconUrl.icWhatsapp})`,
		backgroundSize: '100%',
		height: '100%',
	},
	icSmsShare: {
		display: 'block',
		background: `url(${iconUrl.icSms})`,
		backgroundSize: '100%',
		height: '100%',
	},

	icFacebook: {
		display: 'block',
		background: `url(${iconUrl.icFBShareBig})`,
		backgroundSize: '100%',
		height: '100%',

		[media.MOBILE_OR_TABLET]: {
			background: `url(${iconUrl.icFBShareSmall})`,
			backgroundSize: '100%',
		}
	},
	icEmailShare: {
		display: 'block',
		background: `url(${iconUrl.icEmail})`,
		backgroundSize: '100%',
		height: '100%',
	},
	icUrlShare: {
		display: 'block',
		background: `url(${iconUrl.icUrlLink})`,
		backgroundSize: '100%',
		height: '100%',
	},
 
	icLink: {
		width: 19,
		height: 19
	},

	icFbBgColor: {
		backgroundColor: '#375399'
	},
	icLinkBgColor: {
		backgroundColor: '#0074ff'
	},
	icEmailBgColor: {
		backgroundColor: '#3e4755'
	},

	shareLabel: {
		fontFamily: 'Antenna',
		fontSize: '9px',
		fontWeight: 300,
		fontStyle: 'normal',
		fontStretch: 'normal',
		lineHeight: 'normal',
		letterSpacing: '2px',
		textAlign: 'left',
		color: color.white,
		paddingLeft: 10,
	},

	icShare: {
		display: 'block',
		width: '90px',
		height: '38px',
		display: 'inline-flex',
		alignItems: 'center',
		textDecoration: 'none',
		paddingLeft: 10,
		cursor: 'pointer',

		[media.MOBILE_OR_TABLET]: {
			width: '78px',
			height: '33px',
		}
	},

	icShareDefault: {
		display: 'block',
		width: '90px',
		height: '38px',
		position: 'relative',
		[media.MOBILE_OR_TABLET]: {
			width: '78px',
			height: '33px',
		}
	},
	icShareBtn: {
		padding: 0,
		marginTop: 0,
		border: 'none',
    	background: 'none',
    	outline: 'none',
	},

	icMarginLeft: {
		marginLeft: 10,
	}


});

export const liveIcon = StyleSheet.create({
	icLive: {
		width: '29px',
		height: '13px',
		backgroundImage: `url(${iconUrl.icLive})`,
		backgroundSize: '100%'
	}
});

export const fsgoIcon = StyleSheet.create({
	white: generateFsgoIconStyleObj(iconUrl.fsgoWhite),
	black: generateFsgoIconStyleObj(iconUrl.fsgoBlack)
});

export const keyIcon = StyleSheet.create({
	white: {
		width: '24px',
		height: '10px',
		backgroundImage: `url(${iconUrl.icKey})`,
		backgroundSize: '100%',
		display: 'block'
	}
});

export const foxSportsAppIcon = StyleSheet.create({
    dark: {
        width: '30px',
        height: '30px',
        backgroundImage: `url(${iconUrl.fsAppDark})`,
        backgroundSize: '100% 100%',
        display: 'block',

		[media.MOBILE]: {
            width: '20px',
            height: '20px'
		}
    }
});

/*
	Helpers for styles rendering
 */

function getBaseIconsStyle() {
	return {
		display: 'block',
		backgroundSize: '100%'
	};
}

function generatePlayIconStyleObj(url, size) {
	return Object.assign({}, getBaseIconsStyle(), {
		backgroundImage: `url(${url})`,
		borderRadius: '50%',
		width: size,
		height: size,
	});
}

function generateFsgoIconStyleObj(url) {
	return Object.assign({}, getBaseIconsStyle(), { height: '100%', backgroundImage: `url(${url})` });
}

function generateIcShareStyleObj(url, custom) {
	let base = {
		background: `url(${url})`,

		':hover':{
			transform: 'scale(1.05)'
		}
	};

	return Object.assign({}, base, custom);
}



// WEBPACK FOOTER //
// ./react-app-src/shared/styles/icons.js